import { z } from "zod/v4";

export const GetConfigCompareRequestQueryParamSchema = z.object({
  from: z.string().optional(),
  to: z.string(),
});

export type GetConfigCompareRequestQueryParamType = z.infer<
  typeof GetConfigCompareRequestQueryParamSchema
>;

export const GetConfigCompareResponseBodySchema = z.object({
  diffs: z.any(),
});

export type GetConfigCompareResponseBodyType = z.infer<
  typeof GetConfigCompareResponseBodySchema
>;
